import {
  ItemWrapper,
  ContentWrapper,
  Error,
  InputWrapper,
  ButtonsWrapper,
} from "../../styles";
import { useAppDispatch, useAppSelector } from "../../../../../../app/hooks";

import { CNYProps, FormInputs } from "../../../../../../types/walletTypes";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { savedCNYData } from "../../../../redux/formDataSlice";
import { Button } from "../../../../../../components/common/Button";

import { InputPhone } from "../../../../../../components/common/InputPhone";
import { Input } from "../../../../../../components/common/Input";
import CustomSelect from "../../../../../../components/common/CustomSelect";
import { Relationships } from "../../../../const";
import React from "react";

const BeneficiaryUnionPayForm = ({ handleNext, handlePrevious }: CNYProps) => {
  const getSavedData = useAppSelector((state) => state.formData.cnyData);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<FormInputs>({ defaultValues: getSavedData || {} });

  const dispatch = useAppDispatch();

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    dispatch(savedCNYData(data));
    handleNext?.();
  };

  return (
    <ContentWrapper>
      <ItemWrapper>
        <InputWrapper>
          <Controller
            name="receiverFirstName"
            control={control}
            rules={{ required: "First name is required" }}
            render={({ field }) => (
              <Input
                type="text"
                label="First name"
                value={field.value}
                onChange={field.onChange}
                hasError={!!errors.receiverFirstName}
                labelColor="#FFFFFF"
              />
            )}
          />
          <Error>{errors?.receiverFirstName?.message}</Error>
        </InputWrapper>

        <InputWrapper>
          <Controller
            name="receiverLastName"
            control={control}
            rules={{ required: "Last name is required" }}
            render={({ field }) => (
              <Input
                type="text"
                label="Last name"
                value={field.value}
                onChange={field.onChange}
                hasError={!!errors.receiverLastName}
                labelColor="#FFFFFF"
              />
            )}
          />
          <Error>{errors?.receiverLastName?.message}</Error>
        </InputWrapper>
      </ItemWrapper>

      <InputWrapper>
        <Controller
          name="receiverMobileNumber"
          control={control}
          rules={{ required: "Phone number is required" }}
          render={({ field }) => (
            <InputPhone
              label="Phone number"
              field={field}
              defaultCountry="CN"
            />
          )}
        />
        <Error>{errors?.receiverMobileNumber?.message}</Error>
      </InputWrapper>

      {/*  Requirement from PRODUCT to just leave this here and not send to BE*/}
      <InputWrapper>
        <CustomSelect
          options={Relationships.filter((data) => data.value !== "SELF")}
          $width="100%"
          placeholder="Relationship"
          lightBorder
        />
      </InputWrapper>

      <ButtonsWrapper>
        <Button
          onClick={handlePrevious}
          label="Back"
          height="48px"
          theme="alternate"
          width="203px"
        />
        <Button
          onClick={handleSubmit(onSubmit)}
          label="Continue"
          height="48px"
        />
      </ButtonsWrapper>
    </ContentWrapper>
  );
};

export default BeneficiaryUnionPayForm;
